import { StrictMode, Suspense } from 'react';

import { createRoot } from 'react-dom/client';

import './index.scss';
import './shared/translations/i18n';

import App from './App.tsx';
import { configureAmplifyStandard, configureAmplifyWithOAuth } from './config/amplify.ts';
import LoadingFullScreen from './shared/components/Globals/LoadingFullScreen/LoadingFullScreen.tsx';
import { AUTH_ROUTES, DEEPLINK_URL_PARAM } from './shared/constants/auth.ts';
import { authInterceptor } from './shared/interceptors/auth/auth.interceptor.ts';
import TagManagerService from './shared/services/gtm/tagManagerService.ts';
import { toLocalStorage } from './shared/services/storage/storage.ts';

TagManagerService.initialize();
authInterceptor();

const initialPath = globalThis.location.pathname;
if (AUTH_ROUTES.includes(initialPath)) {
  configureAmplifyWithOAuth();
} else {
  configureAmplifyStandard();
}

if (!AUTH_ROUTES.includes(initialPath) && initialPath !== '/') {
  toLocalStorage(DEEPLINK_URL_PARAM, initialPath);
}

const script = document.createElement('script');
script.src = `https://www.google.com/recaptcha/api.js?render=${import.meta.env.VITE_RECAPTCHA_SITE_KEY}`;
document.head.appendChild(script);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<LoadingFullScreen show={true} />}>
      <App />
    </Suspense>
  </StrictMode>
);
